// extracted by mini-css-extract-plugin
export default {"container":"QQ-z","topReviewHeading":"RQ-z","criticalReview":"SQ-z","favorableReview":"TQ-z","vsSeparator":"UQ-z"};